<!-- 填写未购原因弹窗 -->
<template>
  <a-modal
    okText="完成工单"
    cancelText="继续沟通"
    :width="700"
    v-model:visible="data.visible"
    @ok="handleOk"
    :visible="data.visible"
    :maskClosable="false"
  >
    <template #title>
      <div class="header">
        <h3 class="title">填写未购买原因</h3>
        <span class="tips">(目前检测患者仍未购买处方，如需完成工单，请填写未购原因)</span>
      </div>
    </template>
    <div class="body">
      <a-spin v-if="data.loading" tip="加载中..."></a-spin>
      <a-form v-else ref="formRef" :model="formState" :rules="rules" layout="vertical">
        <a-form-item name="notBuyReasonType" label="未购买原因：">
          <a-radio-group @change="changeRadio" v-model:value="formState.notBuyReasonType">
            <a-radio v-for="option in options" :key="option.value" :value="option.value">
              {{ option.label }}
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="formState.notBuyReasonType === 5" name="notBuyOtherReason">
          <a-textarea
            :maxlength="100"
            :rows="4"
            showCount
            v-model:value="formState.notBuyOtherReason"
            placeholder="请填写未购买原因"
            allow-clear
          />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script setup>
import { feedbackReasonList, finishPurchase } from '@/api/chat'
import { reactive, ref, defineExpose, onMounted, defineEmits, defineProps, computed } from 'vue'

const rules = computed(() => ({
  notBuyReasonType: [
    { type: 'number', required: true, message: '请选择未购买原因', trigger: 'change' }
  ],
  notBuyOtherReason:
    formState.notBuyReasonType === 5
      ? [{ required: true, message: '请填写未购买原因', trigger: ['change', 'blur'] }]
      : []
}))

const emit = defineEmits(['handleOk'])
const options = ref([])
const props = defineProps({
  workOrderId: String
})
const data = reactive({
  loading: false,
  visible: false
})
const formState = reactive({
  notBuyReasonType: null,
  notBuyOtherReason: ''
})
// 暴露出来的方法
const init = () => {
  data.visible = true
  formState.notBuyReasonType = null
  formState.notBuyOtherReason = ''
}
defineExpose({ init })
// 内部方法
const formRef = ref()
const handleOk = () => {
  formRef.value.validate().then(_ => {
    const params = {
      workOrderId: props.workOrderId,
      ...formState
    }
    finishPurchase(params).then(_ => {
      data.visible = false
      emit('handleOk')
    })
  })
}

const getOptions = () => {
  data.loading = true
  feedbackReasonList()
    .then(result => {
      options.value = result.map(m => ({
        ...m,
        label: m.name,
        value: m.code
      }))
    })
    .catch(err => {})
    .finally(() => {
      data.loading = false
    })
}
const changeRadio = () => {
  formState.notBuyOtherReason = ''
  formRef.value.clearValidate()
}
onMounted(() => {
  getOptions()
})
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  .title {
    font-size: 16px;
    color: #333333;
  }
  .tips {
    font-weight: 500;
    font-size: 14px;
    color: #ff9412;
    margin-left: 8px;
  }
}
</style>
